import React, { useState } from 'react';

const WizardStepTimePeriod = ({ onNext, onBack, setWizardData, wizardData }) => {
  const [selectedPeriod, setSelectedPeriod] = useState(wizardData.period || null);

  const periods = [
    {
      id: 'weekly',
      name: 'Weekly',
      description: 'Small amounts invested frequently for consistent growth.',
      icon: '📅',
      recommended: false
    },
    {
      id: 'bi-weekly',
      name: 'Bi-Weekly',
      description: 'Perfect balance of frequency and convenience.',
      icon: '📆',
      recommended: true
    },
    {
      id: 'monthly',
      name: 'Monthly',
      description: 'Popular choice that aligns with monthly budgets.',
      icon: '🗓️',
      recommended: false
    },
    {
      id: 'quarterly',
      name: 'Quarterly',
      description: 'Larger investments with reduced transaction costs.',
      icon: '📊',
      recommended: false
    }
  ];

  const handleSelect = (period) => {
    setSelectedPeriod(period);
    setWizardData({...wizardData, period: period});
  };

  const handleNext = () => {
    if (selectedPeriod) {
      onNext();
    }
  };

  return (
    <div className="min-h-[450px] bg-gradient-to-br from-gray-50 to-gray-200 py-3 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Step Description */}
        <h2 className="text-center text-2xl font-bold text-gray-800 mb-2">Choose your frequency</h2>
        <p className="text-center text-gray-600 mb-4">How often would you like to make deposits toward your {wizardData.metal_type} goal?</p>

        {/* Content Section */}
        <div className="flex justify-center">
          <div className="w-full max-w-3xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {periods.map((period) => (
                <div
                  key={period.id}
                  onClick={() => handleSelect(period.id)}
                  className={`
                    relative bg-white rounded-2xl p-6 cursor-pointer
                    transition-all duration-300 ease-in-out
                    border-2 shadow-md min-h-[240px]
                    hover:transform hover:-translate-y-1 hover:shadow-xl
                    ${selectedPeriod === period.id
                      ? 'border-blue-500 shadow-blue-200 transform -translate-y-1'
                      : period.recommended
                      ? 'border-green-500 shadow-green-100 hover:border-green-500'
                      : 'border-gray-200 hover:border-blue-500'
                    }
                  `}
                >
                  {selectedPeriod === period.id && (
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-blue-500/5 rounded-2xl"></div>
                  )}

                  <div className="relative z-10 flex flex-col items-center text-center h-full">
                    <div className="text-5xl mb-3 opacity-80 transition-opacity duration-300 hover:opacity-100">
                      {period.icon}
                    </div>

                    <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                      {period.name}
                    </h3>

                    <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                      {period.description}
                    </p>

                    {period.recommended && (
                      <div className="mt-3">
                        <span className="inline-flex items-center px-3 py-1 bg-green-500 text-white text-xs font-bold rounded-full">
                          <i className="bi bi-star-fill mr-1"></i>
                          Recommended
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Navigation Section */}
        <div className="flex justify-between mt-6 max-w-3xl mx-auto">
          <button
            onClick={onBack}
            className="bg-white text-black px-6 py-2 rounded-full font-bold border-2 border-black hover:bg-gray-50 transition-colors"
          >
            <i className="bi bi-arrow-left mr-2"></i>
            Back
          </button>
          <button
            onClick={handleNext}
            disabled={!selectedPeriod}
            className={`px-6 py-2 rounded-full font-bold transition-colors ${
              selectedPeriod
                ? 'bg-black text-white hover:bg-gray-800'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Continue
            <i className="bi bi-arrow-right ml-2"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WizardStepTimePeriod;
